import Head from 'next/head';
import Image from 'next/image';
import React, { useState } from 'react';

import shield from '@/assets/images/shield.svg';
import { useItemsStore } from '@/common';
import { Faqcomponent } from '@/common/components/Faq/FaqComponent';
import CallbackForm from '@/common/components/Forex/CallBackForm';
import ForexEasySteps from '@/common/components/Forex/LandingPage/ForexEasySteps';
import LiveExchangeRates from '@/common/components/Forex/LandingPage/LiveExchangeRates';
import ReasonsUseForex from '@/common/components/Forex/LandingPage/ReasonsUseForex';
import WhyOneMuthoot from '@/common/components/Forex/LandingPage/WhyOneMuthoot';
import type { Item, UserDetails } from '@/common/components/Forex/LeadForm';
import LeadForm from '@/common/components/Forex/LeadForm';
import { LandingPageFaq } from '@/utils/constants/forex/faq/index';
import TabsList from '@/utils/constants/forex/TabsList';
import { ForexSEO } from '@/utils/constants/MetaData';

import { TransactionProcess } from '../../enums';
import { ForexTestimonial } from '../ForexTestimonial';

export interface LeadStore {
  items: Item[];
  userDetails: UserDetails;
  transactionProcess: TransactionProcess.Online | TransactionProcess.Branch;
}

const PreLoginLandingPage = () => {
  const [currentTab, setCurrentTab] = useState<string>('BUY');
  const [activeStep, setActiveStep] = useState<number>(1);

  const [leadState, setLeadState] = useState<LeadStore>({
    items: [],
    userDetails: {
      userName: '',
      userEmail: '',
      userPhone: '',
      userCity: '',
      userState: '',
    },
    transactionProcess: TransactionProcess.Online,
  });

  const { setUserDetails } = useItemsStore();

  const handleActiveStep = (step: number) => {
    setActiveStep(step);
  };

  return (
    <>
      <Head>
        <title>{ForexSEO.metaTitle}</title>
        <meta name="description" content={ForexSEO.metaDescription} />
        <meta property="og:description" content={ForexSEO.metaOGDescription} />
        <link rel="canonical" href="https://www.muthootfincorpone.com/forex/" />
      </Head>
      <main className="home withNavHeader bg-prelogin fx">
        {/* Hero section */}
        <section className="bg bg--dark bg--sky home__hero fx-trim-padding">
          <div className="container">
            <div className="row">
              <div className="home__tab nav-ul tab-mb">
                <ul className="nav nav-tabs nav-tabs-trans nav-grid">
                  {TabsList.slice(0, 2).map((eachItem) => (
                    <li className="nav-item nav-item-flink" key={eachItem.id}>
                      <a
                        className={`nav-link nav-tab-li nav-link-padding fx-nav-link ${
                          currentTab === eachItem.activeTab
                            ? 'active-class'
                            : ''
                        }`}
                        data-toggle="tab"
                        onClick={() => {
                          setCurrentTab(eachItem.activeTab);
                          setActiveStep(1);
                          setLeadState({
                            items: [],
                            userDetails: {
                              userName: '',
                              userEmail: '',
                              userPhone: '',
                              userCity: '',
                              userState: '',
                            },
                            transactionProcess: TransactionProcess.Online,
                          });
                          setUserDetails({
                            userName: '',
                            userEmail: '',
                            userPhone: '',
                            userState: '',
                            userCity: '',
                          });
                        }}
                      >
                        <p className="text--white text--bold fx-title">
                          {eachItem.title}
                        </p>
                        <p className="text--white text--regular fx-desc fx-desc-mb text-left">
                          {eachItem.tagLine}
                        </p>
                      </a>
                    </li>
                  ))}
                </ul>
                <ul className="nav nav-tabs nav-tabs-trans nav-grid second-ul">
                  {TabsList.slice(2, 4).map((eachItem) => (
                    <li className="nav-item nav-item-flink" key={eachItem.id}>
                      <a
                        className={`nav-link nav-tab-li nav-link-padding fx-nav-link ${
                          currentTab === eachItem.activeTab
                            ? 'active-class'
                            : ''
                        }`}
                        data-toggle="tab"
                        onClick={() => {
                          setCurrentTab(eachItem.activeTab);
                          setActiveStep(1);
                          setLeadState({
                            items: [],
                            userDetails: {
                              userName: '',
                              userEmail: '',
                              userPhone: '',
                              userCity: '',
                              userState: '',
                            },
                            transactionProcess: TransactionProcess.Online,
                          });
                          setUserDetails({
                            userName: '',
                            userEmail: '',
                            userPhone: '',
                            userState: '',
                            userCity: '',
                          });
                        }}
                      >
                        <p className="text--white text--bold fx-title">
                          {eachItem.title}
                        </p>
                        <p className="text--white text--regular fx-desc fx-desc-mb text-left">
                          {eachItem.tagLine}
                        </p>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="home__tab nav-ul tab-desk">
                <ul className="nav nav-tabs nav-tabs-trans nav-grid ">
                  {TabsList.slice(0, 4).map((eachItem) => (
                    <li
                      className="nav-item nav-item-card nav-item-flink"
                      key={eachItem.id}
                    >
                      <a
                        className={`nav-link nav-tab-li nav-link-padding  ${
                          currentTab === eachItem.activeTab
                            ? 'active-class'
                            : ''
                        }`}
                        data-toggle="tab"
                        onClick={() => {
                          setCurrentTab(eachItem.activeTab);
                          setActiveStep(1);
                          setLeadState({
                            items: [],
                            userDetails: {
                              userName: '',
                              userEmail: '',
                              userPhone: '',
                              userCity: '',
                              userState: '',
                            },
                            transactionProcess: TransactionProcess.Online,
                          });
                          setUserDetails({
                            userName: '',
                            userEmail: '',
                            userPhone: '',
                            userState: '',
                            userCity: '',
                          });
                        }}
                      >
                        <p className="text--white text--bold fx-title">
                          {eachItem.title}
                        </p>
                        <p className="text--white text--regular fx-desc fx-desc-mb text-left">
                          {eachItem.tagLine}
                        </p>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-lg-5 margin-26-px order-1">
                <h1 className="section__title text--white">
                  Currency Exchange <br /> Made Simple
                </h1>
                <p className="section__desc text--white">
                  Seamless <span className="fx-line">|</span> Convenient{' '}
                  <span className="fx-line">|</span> Hassle-Free
                </p>
                <div className="d-flex align-items-center appLinks four-fifty-logo">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={shield}
                    alt="shiled"
                  />
                </div>
              </div>
              <div className="col-lg-7 order-3">
                {activeStep === 1 && (
                  <LeadForm
                    type={currentTab}
                    activeStep={activeStep}
                    handleStep={handleActiveStep}
                    key={currentTab}
                    setLeadState={setLeadState}
                    leadState={leadState}
                    isAvailServices={false}
                  />
                )}
                {activeStep === 2 && (
                  <CallbackForm
                    activeStep={activeStep}
                    handleStep={handleActiveStep}
                    leadState={leadState}
                    setLeadState={setLeadState}
                  />
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Live exchange rates section */}
        <LiveExchangeRates />

        {/* 4 Easy Steps for Forex */}
        <ForexEasySteps />

        {/* Reasons to Buy Sell Forex */}
        <ReasonsUseForex />

        {/* Why Muthoot FinCorp ONE  */}
        <WhyOneMuthoot />

        {/* Customer Testimonial */}
        <ForexTestimonial />

        {/* FAQ's for Forex */}
        {/* Todo After we get the updated content */}
        <Faqcomponent faqData={LandingPageFaq()} />
      </main>
    </>
  );
};

export default PreLoginLandingPage;
